import { render } from "./PhysicianProfileView.vue?vue&type=template&id=6f82392c"
import script from "./PhysicianProfileView.vue?vue&type=script&lang=js"
export * from "./PhysicianProfileView.vue?vue&type=script&lang=js"

import "./PhysicianProfileView.vue?vue&type=style&index=0&id=6f82392c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/physicians/PhysicianProfileView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f82392c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f82392c', __exports__)) {
    console.log('reload')
    api.reload('6f82392c', __exports__)
  }
  
  module.hot.accept("./PhysicianProfileView.vue?vue&type=template&id=6f82392c", () => {
    console.log('re-render')
    api.rerender('6f82392c', render)
  })

}


export default __exports__